import {ReactNode, useState} from "react";
import {Button} from "@/components/ui";
import {ADialog} from "@/components/app/a-dialog";

type Props = {
  title?: string
  children: ReactNode;
  onConfirm: () => void | Promise<boolean | void> | boolean;
  onCancel?: () => void;
}
export const ConfirmDialog = ({children, onConfirm, onCancel, title = "Confirm"}: Props) => {
  const [open, setOpen] = useState(true);
  const handleOnConfirm = async () => {
    const res = await onConfirm();
    if (res !== false) {
      setOpen(false);
    }
  };
  const onClose = () => {
    if (onCancel) {
      onCancel();
    }
    setOpen(false);
  };
  return open ? (
    <ADialog title={title} onClose={onClose}>
      <div className="p-3">
        {children}
        <div className="flex justify-end gap-2 mt-3">
          <Button onClick={onClose} className="btn btn-secondary">Cancel</Button>
          <Button variant="destructive" onClick={handleOnConfirm} className="btn btn-primary">Confirm</Button>
        </div>
      </div>
    </ADialog>
  ) : null;
};